import {FormInstance} from 'antd/lib/form'
import {REQUEST_DATE_FORMAT} from '../../../common/constants'
import {CalculateRequestInterface} from '../types/requests/calculate-request'

export class Extractor {
    private form: FormInstance

    constructor(form: FormInstance) {
        this.form = form
    }

    public extract = (): CalculateRequestInterface => {
        let data = this.form.getFieldsValue()

        return this.extractData(data)
    }

    private extractData = data => {
        data.calcDate = data.calcDate.format(`${REQUEST_DATE_FORMAT} 00:00:00`)
        data.dateEnd = data.dateEnd ? data.dateEnd.format(`${REQUEST_DATE_FORMAT} 00:00:00`) : null

        return data
    }
}
